import { Col, Row } from "reactstrap";
import {
  randomFlyoutKey,
  setBaseDocsAddress,
} from "../utility/FlyoutDocsFactory";
import { CDataTypography } from "./text/CDataTypography";

interface IEmbeddedDocumentation {
  driver: string;
}

const EmbeddedDocumentation = (props: IEmbeddedDocumentation) => {
  const uniqueKey = randomFlyoutKey();
  const baseDocUrl = `${setBaseDocsAddress()}${props.driver}.html`;
  const docUrl = `${baseDocUrl}?hideborders=true&hidepaddingtop=true&onboarding=true&`;

  return (
    <Col className="embedded-documentation">
      <Row className="top-heading-row">
        <Col className="top-heading-contents">
          <CDataTypography
            variant="typography-variant-headline-3"
            className="align-content-center"
          >
            Documentation
          </CDataTypography>
          <div className="expand-link">
            <a href={baseDocUrl} target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-up-right-from-square align-content-center" />
              <CDataTypography
                variant="typography-variant-body-medium"
                color="typography-color-primary"
              >
                Expand
              </CDataTypography>
            </a>
          </div>
        </Col>
      </Row>
      <Row className="doc-container">
        <iframe
          key={uniqueKey}
          className="iframe-doc pe-0"
          src={`${docUrl}${uniqueKey}`}
          title="docs"
        />
      </Row>
    </Col>
  );
};

export default EmbeddedDocumentation;
